class VariantSelects extends HTMLElement {
  constructor () {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange () {
    this.updateOptions()
    this.updateMasterId()
    this.updateExternalVariants()
    this.updatePickupAvailability()

    if (!this.currentVariant) {
      this.setAvailability(false)
    } else {
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.setAvailability(this.currentVariant.available)
    }
  }

  updateOptions () {
    this.options = Array.from(
      this.querySelectorAll('select'),
      select => select.value
    )
  }

  updateMasterId () {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateExternalVariants () {
    // eslint-disable-next-line no-return-assign
    document
      .querySelectorAll('[data-variant-external-id]')
      .forEach(input => (input.value = this.currentVariant.id))
    // eslint-disable-next-line no-return-assign
    document
      .querySelectorAll('[data-variant-external-add]')
      .forEach(button => (button.disabled = !this.currentVariant.available))
  }

  updateURL () {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput () {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability () {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  renderProductInfo () {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.section
      }`
    )
      .then(response => response.text())
      .then(responseText => {
        // Update price display
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        // Update line item properties
        const lineitempropertiesid = `lineitemproperties-${
          this.dataset.section
        }`
        const lineitempropertiesdestination = document.getElementById(
          lineitempropertiesid
        )
        const lineitempropertiessource = html.getElementById(
          lineitempropertiesid
        )

        if (lineitempropertiessource && lineitempropertiesdestination)
          lineitempropertiesdestination.innerHTML =
            lineitempropertiessource.innerHTML

        // eslint-disable-next-line no-unused-expressions
        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )
      })
  }

  setAvailability (isAvailable) {
    const addToBagButtons = window.BAO.utils.getElements(
        '[data-product-add-to-cart]'
    )
    const addToBagTexts = window.BAO.utils.getElements(
        '[data-product-add-to-cart-text]'
    )

    const backInStockButtons = window.BAO.utils.getElements(
        '[data-product-back-in-stock-button]'
    )

    addToBagButtons.forEach(addToBagButton => {
      isAvailable
          ? addToBagButton.removeAttribute('disabled')
          : addToBagButton.setAttribute('disabled', null)

      addToBagButton.setAttribute(
          'aria-hidden',
          !backInStockButtons ? false : !isAvailable
      )
    })

    addToBagTexts.forEach(addToBagText => {
      addToBagText.textContent = isAvailable
          ? window.variantStrings.addToCart
          : window.variantStrings.unavailable
    })

    if (!backInStockButtons) return

    backInStockButtons.forEach(backInStockButtons => {
      backInStockButtons.setAttribute('aria-hidden', isAvailable)
      backInStockButtons.setAttribute(
          'data-variant-id',
          this.currentVariant?.id
      )
    })
  }

  getVariantData () {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
        ?.variants
    return this.variantData
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  updateOptions () {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        radio => radio.checked
      ).value
    })
  }
}

customElements.define('variant-radios', VariantRadios)
